import React, { useEffect, useState } from 'react';
import './About.scss';
import { useHeaderStyle } from '../../Context/HeaderStyle/HeaderStyleContext';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';
import aboutUsBanner from '../../Assets/images/about_us_banner.png';
import aboutUsTrucks from '../../Assets/images/about_us_trucks.png';
import { ABOUT_BANNER, ABOUT_STORY, WHY_WORK_WITH_US } from './aboutData';

const About = () => {
  const { setVariant } = useHeaderStyle();
  const bannerRef = useAnimateOnScroll();
  const storySectionRef = useAnimateOnScroll();
  const storyTextRef = useAnimateOnScroll();
  const storyImageRef = useAnimateOnScroll();
  const [cardsVisible, setCardsVisible] = useState(false);

  useEffect(() => {
    setVariant('solid');
    return () => setVariant('default');
  }, [setVariant]);

  // Exact same scroll trigger as ServiceCards — visible when scrollY >= 10% of viewport
  useEffect(() => {
    let lastVisible = false;
    const handleScroll = () => {
      const next = window.scrollY >= window.innerHeight * 0.1;
      if (next !== lastVisible) {
        lastVisible = next;
        setCardsVisible(next);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <main className="about-page" data-testid="about-page">
      {/* ── Full-viewport banner ─────────────────────────────────────── */}
      <section className="main-wraper banner-cvr">
        <img className="bg-image" src={aboutUsBanner} alt="HaulSync trucks on site" />
        <div className="banner-content about-banner-content">
          <div className="container">
            <div ref={bannerRef} className="banner-inner about-banner-inner slide-down">
              <h1>
                {ABOUT_BANNER.headingLine1}
                <br />
                <span className="text-highlight">{ABOUT_BANNER.headingHighlight}</span>
              </h1>
              <p>{ABOUT_BANNER.description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Why Work With Us ─────────────────────────────────────────── */}
      <section className="why-work-section">
        <div className="container why-work-container">
          <h2 className={`why-work-section__title${cardsVisible ? ' visible' : ''}`}>
            {WHY_WORK_WITH_US.headingPrefix}{' '}
            <span className="text-highlight">{WHY_WORK_WITH_US.headingHighlight}</span>{' '}
            {WHY_WORK_WITH_US.headingSuffix}
          </h2>
          <div className="why-work-cards">
            {WHY_WORK_WITH_US.cards.map((card) => (
              <div
                key={card.id}
                className={`why-work-card${cardsVisible ? ' visible' : ''}`}
                style={{ '--delay': card.delay }}
              >
                <img src={card.icon} alt={card.iconAlt} className="why-work-card__icon" />
                <h3 className="why-work-card__title">{card.title}</h3>
                <p className="why-work-card__description">{card.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* ── About Story ──────────────────────────────────────────────── */}
      <section ref={storySectionRef} className="about-story slide-up">
        <div className="container about-story__inner">
          <div ref={storyImageRef} className="about-story__col-image scale-in">
            <img
              src={aboutUsTrucks}
              alt={ABOUT_STORY.imageAlt}
              className="about-story__truck-img"
            />
          </div>
          <div ref={storyTextRef} className="about-story__col-text right-in">
            {ABOUT_STORY.sections.map((section) => (
              <div key={section.id} className="about-story__segment">
                <h2 className="about-story__heading">
                  {section.headingPrefix}{' '}
                  <span className="about-story__heading-highlight">
                    {section.headingHighlight}
                  </span>
                </h2>
                <p className="about-story__description">{section.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
